import { render, staticRenderFns } from "./StudentSignUpCourse.vue?vue&type=template&id=c44ee83a"
import script from "./StudentSignUpCourse.vue?vue&type=script&lang=js"
export * from "./StudentSignUpCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports